define('commons/check-disable-field',['jquery'], function($) {

    var CheckDisableField = function(checkboxId, fieldToDisableId) {
        var checkbox = $("#" + checkboxId);
        var fieldToDisable = $("#" + fieldToDisableId);
        var messageToDisplay = checkbox.parent().find(".help");
        checkbox.change(function() {
            if (checkbox.prop("checked")) {
                fieldToDisable.prop("disabled", true);
                messageToDisplay.css("display", "");
            } else {
                fieldToDisable.prop("disabled", false);
                messageToDisplay.css("display", "none");
            }
        });
        fieldToDisable.parent().click(function() {
            checkbox.prop("checked",false);
            checkbox.change();
        });
        if (fieldToDisable.parent().find(".error").length > 0) {
            checkbox.prop("checked",true);
        }
        checkbox.change();
    };

    return CheckDisableField;
});
